(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWwalrus_atlas_", frames: [[612,860,208,208],[822,1066,176,176],[326,1122,158,170],[0,1124,158,170],[160,1168,156,170],[172,956,152,210],[322,336,206,314],[530,544,206,314],[738,544,204,314],[612,1070,176,162],[0,336,320,268],[568,272,320,270],[568,0,320,270],[284,0,282,334],[0,0,282,334],[822,860,182,204],[428,860,182,260],[214,652,212,302],[0,606,212,302],[890,0,82,74],[890,76,82,74],[486,1234,140,98],[0,910,170,212]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.WalrusFin0001 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.WalrusFin0002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.WalrusFin_excited = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.WalrusFin_excited_002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.WalrusHead_0030001 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.WalrusHead_0030002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.WalrusHead_excited_003 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.WalrusNeck = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll10002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll10003 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll10004 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll20001 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll20002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll3 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll4 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll70001 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll70002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll80001 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.WalrusRoll80002 = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.WalrusShoulder = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.WalrusTail = function() {
	this.spriteSheet = ss["MWwalrus_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.walrus_tummyMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:29,clean:53});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_29 = function() {
		/* stop();*/
	}
	this.frame_53 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29).call(this.frame_29).wait(24).call(this.frame_53).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACqEFIgSgFIm9gBQk/gegpgIQg1gLgWgRQgWgRAAggQAIgTALgSQgEgGgCgJQgCgFAAgiQAMgnASgnQAjhQAdAAIAjACQgLg1AAgSQgEgQAFgPQALgdAuAAQA0AABPAuQBKAxAMAEQAEgHACAAQgCgTAMgRQARgaAoAAQAoAAA1AYIBiAyIAAgDQACgnAKgYQASgnAsgVQAngCA0AcQAfARBFApIAAAAQAHg6AagOQAwgaBcCaQB7gDApBKQANAZAEAlQAdgGAiABQA/ACAoAZQAuAfAAA4IACALQAAALgFAKQgDAHgHAGQANANAAAQQAAAqgvAFQiJAMhzAGgAoTiMIADgDIgEgCg");
	this.shape.setTransform(75.1,26.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},24).wait(41));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,150.2,52.2);


(lib.walrus_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AE3hfQhggUlBhPQlChPhGBlQhFBmBKBlQBLBmAjAlQAjAlAOgFIEoAWQAYgCBKgCQAGgBAGAAQAegBATgDQAtAMA4ACQAkACBBgEQBjgHATgBQAfgBAZgkQAYgiAIgwQAIgxgNgnQgPgrgogOQg+gehggUg");
	this.shape.setTransform(54.7,25.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.walrus_tummyGlow, new cjs.Rectangle(-1.5,-0.4,112.5,52), null);


(lib.walrus_mouthGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ADwBCQAAhGgxg4QgsgxhAgUQhAgUgrATQgDABgDACQgkgIgwAWQg0AXgiAsQgoAxAAA7QAAADAAAiQAGAhAeAAQAbgiAWgZQAFAOAMAPQAhAnBCAAQA6AAAjgbQAdAKAiAAQBcAAAQgVQAQgWgBgPg");
	this.shape.setTransform(24.1,14.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.walrus_mouthGlow, new cjs.Rectangle(-3,-3,54.1,34.2), null);


(lib.walrus_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AhiFHIAAAAIgogHIgBgBIghgJIgEgBIgMgHIgDgBIgBAAQgmgPgXgZQgogoAAhUQAAgtAOgdIAAAAQAIgRAAgVIgCg8IgDg8IgBgWIgDgRIAAAAIgDgQIgDgHQgNgYAAgrQgCg8A+gfIgBAAQAugYBIAEQBEAFA7AdIAAABQBEAiAhA2IAAABIAEAGIACADIABABIAZAkIAMAOIASARIgBAAQAQAOAmAcIAAABQAiAaAMAUIAAAAQAUAdAAAwQABAVgSA7QAQAGAFAKIAAABQALARgCAIIAAAFQgDAYgLAIQgBABADAOQADAPgCAEIABAHQAAAkg7AEIgEABQgGAggzAFIABAAIgXACQgNAPggADIABAAQguAGgtAAQg3AAg4gJgAhZEMIABAAQBbAPBdgMIABAAQAEgBgBAGQACgJAHgGQAHgFAJgBIAmgFIAAgFQABgLAHgIIAHgGQAGgDAHgBIAMgBIACgBIAHAAIAAgIQABgKAIgIQAEgEAFgCQgEgHABgHIAAgBQgGgBgGgDQgJgGgEgKQgDgJADgKQAYhKABgWQAAgcgKgRIAAAAQgJgNgXgSIAAABQgqgggRgQIgBAAIgTgTIgBgCIgNgPIgCgCIgbgmIAAgBIgEgFIgEgHIAAAAQgZgpgzgaIAAAAQgxgYg4gEQg0gDgiARIAAAAQgaANgBAYQAAAZAGANIABADIAGAOIABAFIAEAVIAAgBIADAUIABACIABAWIAAACIADA8QACAnAAAYQgBAjgNAcIAAABQgIASAAAeQAAA4AYAbQAPAQAaAJIACACIABAAIADABIAIAFIAfAIIgCAAIAkAHgAiYD/IAAgBIgBgBIABACg");
	this.shape.setTransform(27,30.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.walrus_footGlow, new cjs.Rectangle(-3,-3,61.5,67.3), null);


(lib.walrus_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ABSAnQgVgKgkgOQg4gXgfgRQgHgEhzg8QiTi+j5hBQAAE4ESC1QERC1DdANQDdANCLhNQCLhMnBhhQh6g0gigPg");
	this.shape.setTransform(45.6,12.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.walrus_backGlow, new cjs.Rectangle(-15.5,-24.8,122.2,75), null);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AE3hfQhggUlBhPQlChPhGBlQhFBmBKBlQBLBmAjAlQAjAlAOgFIEoAWQAYgCBKgCQAGgBAGAAQAegBATgDQAtAMA4ACQAkACBBgEQBjgHATgBQAfgBAZgkQAYgiAIgwQAIgxgNgnQgPgrgogOQg+gehggUg");
	this.shape.setTransform(54.7,25.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(-1.5,-0.4,112.5,52), null);


(lib.blueglowmouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("ADwBCQAAhGgxg4QgsgxhAgUQhAgUgrATQgDABgDACQgkgIgwAWQg0AXgiAsQgoAxAAA7QAAADAAAiQAGAhAeAAQAbgiAWgZQAFAOAMAPQAhAnBCAAQA6AAAjgbQAdAKAiAAQBcAAAQgVQAQgWgBgPg");
	this.shape.setTransform(24.1,14.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmouth, new cjs.Rectangle(-3,-3,54.1,34.2), null);


(lib.blueglowfin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0099FF").s().p("AhiFHIAAAAIgogHIgBgBIghgJIgEgBIgMgHIgDgBIgBAAQgmgPgXgZQgogoAAhUQAAgtAOgdIAAAAQAIgRAAgVIgCg8IgDg8IgBgWIgDgRIAAAAIgDgQIgDgHQgNgYAAgrQgCg8A+gfIgBAAQAugYBIAEQBEAFA7AdIAAABQBEAiAhA2IAAABIAEAGIACADIABABIAZAkIAMAOIASARIgBAAQAQAOAmAcIAAABQAiAaAMAUIAAAAQAUAdAAAwQABAVgSA7QAQAGAFAKIAAABQALARgCAIIAAAFQgDAYgLAIQgBABADAOQADAPgCAEIABAHQAAAkg7AEIgEABQgGAggzAFIABAAIgXACQgNAPggADIABAAQguAGgtAAQg3AAg4gJgAhZEMIABAAQBbAPBdgMIABAAQAEgBgBAGQACgJAHgGQAHgFAJgBIAmgFIAAgFQABgLAHgIIAHgGQAGgDAHgBIAMgBIACgBIAHAAIAAgIQABgKAIgIQAEgEAFgCQgEgHABgHIAAgBQgGgBgGgDQgJgGgEgKQgDgJADgKQAYhKABgWQAAgcgKgRIAAAAQgJgNgXgSIAAABQgqgggRgQIgBAAIgTgTIgBgCIgNgPIgCgCIgbgmIAAgBIgEgFIgEgHIAAAAQgZgpgzgaIAAAAQgxgYg4gEQg0gDgiARIAAAAQgaANgBAYQAAAZAGANIABADIAGAOIABAFIAEAVIAAgBIADAUIABACIABAWIAAACIADA8QACAnAAAYQgBAjgNAcIAAABQgIASAAAeQAAA4AYAbQAPAQAaAJIACACIABAAIADABIAIAFIAfAIIgCAAIAkAHgAiYD/IAAgBIgBgBIABACg");
	this.shape.setTransform(27,30.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowfin, new cjs.Rectangle(-3,-3,61.5,67.3), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("ABSAnQgVgKgkgOQg4gXgfgRQgHgEhzg8QiTi+j5hBQAAE4ESC1QERC1DdANQDdANCLhNQCLhMnBhhQh6g0gigPg");
	this.shape.setTransform(45.6,12.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-15.5,-24.8,122.2,75), null);


(lib.WalrusTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusTail();
	this.instance.parent = this;
	this.instance.setTransform(-39.9,-47.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusTail_1, new cjs.Rectangle(-39.9,-47.4,85,106), null);


(lib.WalrusShoulder_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusShoulder();
	this.instance.parent = this;
	this.instance.setTransform(-33.5,-19.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusShoulder_1, new cjs.Rectangle(-33.5,-19.9,70,49), null);


(lib.WalrusRoll7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,"clean":2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:240,"final":241,final_loop:242});

	// Layer 4
	this.instance = new lib.WalrusRoll70001();
	this.instance.parent = this;
	this.instance.setTransform(-50.4,-78.9,0.5,0.5);

	this.instance_1 = new lib.WalrusRoll70002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-50.4,-78.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},235).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.3,-78.9,150.2,151);


(lib.WalrusRoll4_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusRoll4();
	this.instance.parent = this;
	this.instance.setTransform(-43.9,-64.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll4_1, new cjs.Rectangle(-43.9,-64.4,91,130), null);


(lib.WalrusRoll3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusRoll3();
	this.instance.parent = this;
	this.instance.setTransform(-43.9,-48.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll3_1, new cjs.Rectangle(-43.9,-48.9,91,102), null);


(lib.WalrusRoll1_excited_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#71647E").s().p("Ai/KxQlWgOkVinQhPjhACjwQABjrBQjOQA0gfAxgWQAegPAzgUQBTgiAtgZQARgJBwgyQArgSAfgTQAQgKAagSIARgVQAFAwCoBpQBhA+EMCRQCQBODTAdQDTAeARB5QARB4jEDaQjDDaikBXQjdB4kLAAIg0gCg");
	this.shape.setTransform(-16.1,18.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll1_excited_005, new cjs.Rectangle(-104.9,-50.5,177.7,138.1), null);


(lib.WalrusRoll1_excited_003b = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#71647E").s().p("AgLLLQlugcjihfQhNgggxgkQgmgbgFgOQhPjiACjwQABjqBQjPQA0geAxgXQAegOAzgVQBTgiAtgYQARgKBwgxQArgTAfgTQAQgJAagTIARgUQAGA1CSCpQCQCnC5CnQDMC4CSBWQCrBkAthCQg6B1gkA2QgnA7gzAvQiwCeiiBIQiSBAiRAAQgZAAgYgBg");
	this.shape.setTransform(-19.9,21.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll1_excited_003b, new cjs.Rectangle(-104.9,-50.5,170.1,143.3), null);


(lib.WalrusRoll1_excited_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#71647E").s().p("Ap8IOQgggPgOgnQhPjhACjwQABjrBQjOQA0gfAxgWQAegPAzgUQBTgiAtgZQARgJBwgyQArgSAfgTQAQgKAagSIARgVQAJBUEjFQIDeD+QBzCEAiA1QAeAvBTB7QBGB2ANBgQgLACgeAUIhHAwQh1BKiCAiQh7AgiIAAQlXAAm0jJg");
	this.shape.setTransform(-28.9,22.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll1_excited_003, new cjs.Rectangle(-104.9,-50.5,152.1,145.4), null);


(lib.WalrusRoll1_excited_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#71647E").s().p("AAXKxQmZg9j6hOQgggOgOgoQhPjhACjwQABjrBQjOQA0gfAxgWQAegPAzgUQBTgiAtgZQARgJBwgyQArgSAfgTQAQgKAagSIARgVQAJBUEjFQIDeD+QBzCEAiA1QAeAvBTB7QBGB2ANBgQj+CikvAAQhYAAhdgOg");
	this.shape.setTransform(-28.9,19.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll1_excited_001, new cjs.Rectangle(-104.9,-50.5,152.1,140.6), null);


(lib.WalrusRoll_excited_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#71647E").s().p("AGDJ+IrpAAQgjgDhsgEQhtgDgagNQgggOgOgoQhPjiACjwQABjqBQjPQA0geAxgXQAegOAzgVQBTgiAtgYQARgKBwgxQArgTAfgTQAQgJAagTIARgUQAJBUEjFQIDeD9QBzCEAiA2QAeAuBTB7QBGB2ANBhQhtAShhAHQhcAHhFAAIgHAAg");
	this.shape.setTransform(-28.9,13.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusRoll_excited_001, new cjs.Rectangle(-104.9,-50.5,152.1,127.6), null);


(lib.WalrusNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusNeck();
	this.instance.parent = this;
	this.instance.setTransform(-40,-32.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusNeck_1, new cjs.Rectangle(-40,-32.9,88,81), null);


(lib.WalrusHead_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.WalrusHead_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-50,-29,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusHead_excited_003_1, new cjs.Rectangle(-50,-29,102,157), null);


(lib.WalrusFin_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.WalrusFin_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-37,-40,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusFin_excited_002_1, new cjs.Rectangle(-37,-40,76,105), null);


(lib.WalrusFin_excited_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.WalrusFin_excited();
	this.instance.parent = this;
	this.instance.setTransform(-40,-40,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.WalrusFin_excited_1, new cjs.Rectangle(-40,-40,78,85), null);


(lib.WalrusRoll8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":240,"final":241,"final_loop":242});

	// Layer 4
	this.instance = new lib.WalrusRoll80001();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.instance_1 = new lib.WalrusRoll80002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},237).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2,-2,41,37);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.WalrusRoll2_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":69});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-90.9,70.1,0.851,0.851,-117.2,0,0,35.6,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-81.6,43.4,0.955,0.955,-151,0,0,35.6,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-35.1,51.3,0.955,0.955,16.8,0,0,35.5,10.7);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-59.6,72.5,0.8,0.8,68.7,0,0,35.5,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},68).wait(43));

	// Layer 3
	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-142.4,62.8,0.8,0.8,-58,0,0,35.7,11);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-124.3,54.7,0.8,0.8,179.2,0,0,36.1,11.7);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-162.4,61.5,0.8,0.8,-67.1,0,0,35.4,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]},4).to({state:[]},65).wait(43));

	// Layer 2
	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(45.3,62,0.869,0.869,-0.5,0,0,35.5,11.3);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(7).to({_off:false},0).to({_off:true},62).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.WalrusRoll2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,glowclean:101,glowclean_loop:102,"final":103,"final_loop":104});

	// Layer 4
	this.instance = new lib.WalrusRoll20001();
	this.instance.parent = this;
	this.instance.setTransform(-68.4,-80.4,0.5,0.5);

	this.instance_1 = new lib.WalrusRoll20002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-68.4,-80.4,0.5,0.5);

	this.instance_2 = new lib.walrus_tummyGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-60.3,25.2,2.5,2.5,0,0,180,54.6,25.6);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(-60.3,25.2,2.5,2.5,0,0,180,54.6,25.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},94).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(141));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-92.1,-80.4,164.7,182.4);


(lib.WalrusRoll1_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-46.9,-22.4,0.739,0.739,-99,0,0,35.6,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-87.1,-31.8,0.739,0.739,-137,0,0,35.5,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).to({state:[]},24).wait(15));

	// Layer 3
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-74.6,-7.5,0.739,0.739,58.7,0,0,35.5,10.7);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-50.8,-36.9,0.739,0.739,36.7,0,0,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},5).to({state:[]},47).to({state:[]},24).wait(8));

	// Layer 2
	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-21.7,-65.8,0.613,0.613,-153,0,0,35.6,10.7);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-118.2,-9.7,0.657,0.657,47.3,0,0,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5},{t:this.instance_4}]},9).to({state:[]},51).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.WalrusHead_003_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(21.1,17.8,0.748,0.748,6.5,0,0,35.4,10.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.8,20.9,0.748,0.748,61.4,0,0,35.3,10.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).to({state:[]},24).wait(17));

	// Layer 2
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(15,24.5,0.748,0.748,-135.3,0,0,35.3,10.2);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(2.4,96.6,0.474,0.474,-122.4,0,0,35.4,10.9);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(5.1,75.6,0.57,0.57,175.4,0,0,35.5,10.9);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.2,84.9,0.57,0.57,-16.4,0,0,35.4,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},4).to({state:[]},48).to({state:[]},26).wait(8));

	// Layer 3
	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(26.6,35.9,0.474,0.474,-75.2,0,0,35.8,10.8);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(15.5,55.7,0.474,0.474,145.3,0,0,35.5,10.8);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-6.9,59.8,0.57,0.57,-4.2,0,0,35.5,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6}]},8).to({state:[]},52).wait(26));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.WalrusHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":90,"glowclean":91,"glowclean_loop":92,"final":93,"final_loop":94});

	// Layer 2
	this.instance = new lib.WalrusHead_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-50,-29,0.5,0.5);

	this.instance_1 = new lib.WalrusHead_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-50,-29,0.5,0.5);
	this.instance_1._off = true;

	this.instance_2 = new lib.walrus_mouthGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(7.6,12.9,1.25,1.25,0,0,0,24.1,13.9);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(7.6,12.9,1.25,1.25,0,0,0,24.1,13.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},8).to({state:[{t:this.instance_1}]},76).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(191));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false},0).wait(87).to({_off:true},2).wait(191));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-29,103,157);


(lib.WalrusFin_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-6.4,7.5,0.743,0.743,115.6,0,0,35.7,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3.3,27.4,0.71,0.71,68.6,0,0,35.7,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(11.7,-5.9,0.71,0.71,-104.9,0,0,35.7,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-23.8,3.5,0.6,0.6,158.3,0,0,35.5,11.1);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(23.4,20.2,0.6,0.6,0,0,0,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.WalrusFin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 7
	this.instance = new lib.WalrusFin0001();
	this.instance.parent = this;
	this.instance.setTransform(-40,-40,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3.7,9.9,0.749,0.749,0,29.9,-150.1,50.6,5.2);

	this.instance_2 = new lib.WalrusFin0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-40,-40,0.5,0.5);

	this.instance_3 = new lib.walrus_footGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0,3,1.25,1.25,0,0,180,27,30.6);

	this.glow = new lib.blueglowfin();
	this.glow.parent = this;
	this.glow.setTransform(0,3,1.25,1.25,0,0,180,27,30.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_2},{t:this.instance_1}]},57).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(171));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.1,-40,81.2,85);


(lib.water_drops_008 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(182.5,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,19.8,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,36.8,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(105.1,-9.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,0.3,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,-9.6,18,23);


(lib.walrus_tummyMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":56,"clean":68});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}
	this.frame_68 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(56).call(this.frame_56).wait(12).call(this.frame_68).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-7.3,39.1,0.851,0.851,-117.2,0,0,35.6,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(2,12.3,0.955,0.955,-151,0,0,35.6,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(48.5,20.2,0.955,0.955,16.8,0,0,35.5,10.7);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24,41.5,0.8,0.8,68.7,0,0,35.5,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},55).wait(24));

	// Layer 3
	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-58.7,31.8,0.8,0.8,-58,0,0,35.7,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-40.7,23.6,0.8,0.8,179.2,0,0,36.1,11.7);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-78.8,30.5,0.8,0.8,-67.1,0,0,35.4,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]},4).to({state:[]},52).wait(24));

	// Layer 2
	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(128.9,30.9,0.869,0.869,-0.5,0,0,35.5,11.2);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(7).to({_off:false},0).to({_off:true},49).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.walrus_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"final":62,"final_loop":63});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABuDtQhQABhOgEQhNgChOAAIidAAIigABQgvABgugEIgEgCIgJAAQgDgIgFgDQgVgNgbgKIgTgdIgCgCQgOgRgKgWIAAgCIAAAAIAAgBQgEgGgCgIQgBgGAAghQAMgoARgnQAjhPAdAAIAkABQgMg0AAgSQgEgQAGgPQAKgdAuAAQA0AABQAuQBKAwAMAFQAEgIACAAQgCgSALgSQASgZAnAAQAoAAA2AYIBiAxIAAgDQABgmALgYQARgoAsgUQAngCA1AcQAeAQBFApIABABQAGg6AbgPQAvgaBdCaQB6gDApBLQAOAYAEAlQAdgGAhABQAvACAiAOIgBABQALANAEAPIAAACIAGALIAJAiIAEAEIAAAHIALAVIAGAjIgQAZIgJAHQhRARhVADQhHAChIgBQhDgBhBAEIgBAAIgCAAIgHAAIgIgDIAIAEQhKgFhLAAgAoOh5IADgDIgEgCgArYB7IABABIgGAJIAFgKgArXB8g");
	this.shape.setTransform(74.7,24.2);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(40,34.9,1.673,1.673,175,0,0,46.7,9.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},9).to({state:[{t:this.instance}]},46).to({state:[]},1).to({state:[]},162).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.2,0,147,48.5);


(lib.walrus_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"final":102,"final_loop":103});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAWDjQgNgKgLgNQgJAQgSAKQgWAMgeAAQggAAgYgIQgYgIgPAAQg5AAgNgsQgGgWAFgXQAAgRAJgqQgZgLgJgeQgGgXADgWIAAgBQAggPAdgRQA/gQA8gZQAigIAYgUIAegUQA+grBLgVIAJAAIACgCQAvgSApghQAsAuAABlQAAAWgLAPQgRAXg0AdQgRAKgCAcQABAkgBAQQABAugLApQgWBShDAAQggAAgZgVg");
	this.shape.setTransform(27.7,28.4);

	this.instance = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(25.4,32.2,0.987,0.987,162.2,0,0,35.8,10.8);

	this.instance_1 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(38.6,20,1.287,1.287,162,0,0,35.7,10.8);

	this.instance_2 = new lib.walrus_backGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.3,18.7,1.5,1.5,0,0,180,45.6,12.7);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(24.3,18.7,1.5,1.5,0,0,180,45.6,12.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_1},{t:this.instance}]},88).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},1).to({state:[]},121).wait(81));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,3.6,55.5,49.6);


(lib.WalrusRoll1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 5
	this.tummymud = new lib.walrus_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(-26.1,55.5,1,1,0,0,0,75.1,26.1);

	this.backmud = new lib.walrus_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(-68.1,-23.2,1,1,0,0,0,27.7,26.6);

	this.instance = new lib.WalrusRoll10002();
	this.instance.parent = this;
	this.instance.setTransform(-107,-52.4,0.5,0.5);

	this.instance_1 = new lib.WalrusRoll10003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-107,-52.4,0.5,0.5);

	this.instance_2 = new lib.WalrusRoll10004();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-107,-52.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-107,-52.4,160,134);


(lib.Walrus = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rest:0,rest_stop:82,wrongAnswer:84,"clean":136,clean_stop:154,wet:156,wet_stop:174,excited:176,excited_stop:341,animalSound:343});

	// timeline functions:
	this.frame_82 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_134 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_154 = function() {
		/* stop();*/
	}
	this.frame_174 = function() {
		/* stop();*/
	}
	this.frame_341 = function() {
		/* 
		
		gameObjects._game.done();
		
		stop();*/
	}
	this.frame_404 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(82).call(this.frame_82).wait(52).call(this.frame_134).wait(20).call(this.frame_154).wait(20).call(this.frame_174).wait(167).call(this.frame_341).wait(63).call(this.frame_404).wait(1));

	// Walrus Roll 2_bubbles
	this.tummy_bubbles = new lib.WalrusRoll2_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(116.3,105.8,0.29,0.29,0,0,180,0,-0.7);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).to({_off:true},156).wait(249));

	// Walrus Head
	this.mouth_bubbles = new lib.WalrusHead_003_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(117.6,83.4,0.33,0.33,0,0,180,-50.4,14.1);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).to({_off:true},156).wait(249));

	// Walrus fin
	this.foot_bubbles = new lib.WalrusFin_bubbles();
	this.foot_bubbles.parent = this;
	this.foot_bubbles.setTransform(113.2,118.2,0.348,0.348,0,0,180,16.2,-27.3);

	this.timeline.addTween(cjs.Tween.get(this.foot_bubbles).to({_off:true},156).wait(249));

	// Walrus Torso
	this.back_bubbles = new lib.WalrusRoll1_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(124.3,106.9,0.29,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},156).wait(249));

	// Layer 2
	this.instance = new lib.water_drops_008();
	this.instance.parent = this;
	this.instance.setTransform(128.8,110.7,0.4,0.4,0,0,180,92.5,49.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(156).to({_off:false},0).to({_off:true},20).wait(229));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(176.1,124.4,0.353,0.353,0,0,180);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(337).to({_off:false},0).to({_off:true},6).wait(62));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(147.7,103.3,0.568,0.568,0,0,180);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(331).to({_off:false},0).to({_off:true},12).wait(62));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(113.2,118.2,0.679,0.679,0,0,180);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(324).to({_off:false},0).to({_off:true},19).wait(62));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(117.6,83.4,0.423,0.423,0,0,180);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(316).to({_off:false},0).to({_off:true},27).wait(62));

	// Layer 4
	this.instance_5 = new lib.WalrusShoulder_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(114.5,106.5,0.328,0.29,0,31.2,-148.8);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(200).to({_off:false},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:52.9,skewY:-127.1,x:115.9,y:101.9},0).wait(2).to({scaleY:0.29,skewX:74.7,skewY:-105.3,x:117.4,y:97.3},0).wait(2).to({scaleX:0.33,skewX:96.2,skewY:-83.8,x:118.8,y:92.7},0).wait(2).to({scaleX:0.33,scaleY:0.22,skewX:106.1,skewY:-85.5,x:120.4,y:92.3},0).wait(2).to({scaleX:0.32,scaleY:0.16,skewX:116.2,skewY:-86.9,x:122.1,y:91.8},0).wait(2).to({scaleX:0.32,scaleY:0.2,skewX:109.5,skewY:-86,x:120.9,y:92.2},0).wait(2).to({scaleX:0.33,scaleY:0.25,skewX:102.8,skewY:-85,x:119.9,y:92.4},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:96.2,skewY:-83.8,x:118.8,y:92.7},0).wait(2).to({scaleX:0.33,scaleY:0.22,skewX:106.1,skewY:-85.5,x:120.4,y:92.3},0).wait(2).to({scaleX:0.32,scaleY:0.16,skewX:116.2,skewY:-86.9,x:122.1,y:91.8},0).wait(2).to({scaleX:0.32,scaleY:0.2,skewX:109.5,skewY:-86,x:120.9,y:92.2},0).wait(2).to({scaleX:0.33,scaleY:0.25,skewX:102.8,skewY:-85,x:119.9,y:92.4},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:96.2,skewY:-83.8,x:118.8,y:92.7},0).wait(2).to({scaleX:0.33,scaleY:0.22,skewX:106.1,skewY:-85.5,x:120.4,y:92.3},0).wait(2).to({scaleX:0.32,scaleY:0.16,skewX:116.2,skewY:-86.9,x:122.1,y:91.8},0).wait(2).to({scaleX:0.32,scaleY:0.2,skewX:109.5,skewY:-86,x:120.9,y:92.2},0).wait(2).to({scaleX:0.33,scaleY:0.25,skewX:102.8,skewY:-85,x:119.9,y:92.4},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:96.2,skewY:-83.8,x:118.8,y:92.7},0).wait(6).to({scaleX:0.33,skewX:73.4,skewY:-106.6,x:116.8,y:99.5},0).wait(2).to({skewX:50.4,skewY:-129.6,x:114.8,y:106.3},0).wait(2).to({scaleX:0.33,skewX:27.5,skewY:-152.5,x:112.9,y:113},0).to({_off:true},2).wait(157));

	// Layer 3
	this.instance_6 = new lib.WalrusFin_excited_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(112,112.3,0.365,0.348,0,56.7,-105.5,16.4,-27.6);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(200).to({_off:false},0).wait(2).to({regX:16.2,regY:-28.1,scaleX:0.36,skewX:78.5,skewY:-89.7,x:112.4,y:105.9},0).wait(2).to({regX:16.6,regY:-27.4,scaleX:0.35,skewX:100,skewY:-74.2,x:112.3,y:99.3},0).wait(2).to({regX:16.1,regY:-27.8,scaleX:0.35,skewX:121.7,skewY:-58.3,x:112.5,y:93},0).wait(2).to({regX:16,regY:-27.5,scaleX:0.36,scaleY:0.35,skewX:128.1,skewY:-71.2,x:115.6,y:92.1},0).wait(2).to({regX:15.8,regY:-27.4,scaleX:0.38,scaleY:0.35,skewX:134.7,skewY:-84.1,x:118.9,y:91.3},0).wait(2).to({scaleX:0.37,scaleY:0.35,skewX:130.3,skewY:-75.5,x:116.7,y:91.9},0).wait(2).to({regY:-27.3,scaleX:0.36,scaleY:0.35,skewX:126.1,skewY:-66.9,x:114.6,y:92.4},0).wait(2).to({regX:16.1,regY:-27.8,scaleX:0.35,skewX:121.7,skewY:-58.3,x:112.5,y:93},0).wait(2).to({regX:16,regY:-27.5,scaleX:0.36,scaleY:0.35,skewX:128.1,skewY:-71.2,x:115.6,y:92.1},0).wait(2).to({regX:15.8,regY:-27.4,scaleX:0.38,scaleY:0.35,skewX:134.7,skewY:-84.1,x:118.9,y:91.3},0).wait(2).to({scaleX:0.37,scaleY:0.35,skewX:130.3,skewY:-75.5,x:116.7,y:91.9},0).wait(2).to({regY:-27.3,scaleX:0.36,scaleY:0.35,skewX:126.1,skewY:-66.9,x:114.6,y:92.4},0).wait(2).to({regX:16.1,regY:-27.8,scaleX:0.35,skewX:121.7,skewY:-58.3,x:112.5,y:93},0).wait(2).to({regX:16,regY:-27.5,scaleX:0.36,scaleY:0.35,skewX:128.1,skewY:-71.2,x:115.6,y:92.1},0).wait(2).to({regX:15.8,regY:-27.4,scaleX:0.38,scaleY:0.35,skewX:134.7,skewY:-84.1,x:118.9,y:91.3},0).wait(2).to({scaleX:0.37,scaleY:0.35,skewX:130.3,skewY:-75.5,x:116.7,y:91.9},0).wait(2).to({regY:-27.3,scaleX:0.36,scaleY:0.35,skewX:126.1,skewY:-66.9,x:114.6,y:92.4},0).wait(2).to({regX:16.1,regY:-27.8,scaleX:0.35,skewX:121.7,skewY:-58.3,x:112.5,y:93},0).wait(6).to({regY:-27.9,scaleX:0.35,skewX:98.8,skewY:-75.4,x:111.9,y:101.6},0).wait(2).to({regY:-27.6,scaleX:0.36,scaleY:0.35,skewX:76,skewY:-92.1,x:111.2,y:110.1},0).wait(2).to({regX:16.4,scaleX:0.37,scaleY:0.35,skewX:53,skewY:-109.2,x:110.7,y:118.9},0).to({_off:true},2).wait(157));

	// Walrus Head
	this.walrus_head = new lib.WalrusHead_003();
	this.walrus_head.parent = this;
	this.walrus_head.setTransform(117.6,83.4,0.33,0.33,0,0,180,-50.4,14.1);

	this.walrus_head_1 = new lib.WalrusHead_excited_003_1();
	this.walrus_head_1.parent = this;
	this.walrus_head_1.setTransform(117.6,83.4,0.33,0.33,0,0,180,-50.4,14.1);
	this.walrus_head_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.walrus_head).wait(32).to({regX:-50.2,skewX:-0.3,skewY:179.7,x:115.2,y:86.2},0).wait(2).to({regX:-50.3,regY:14.2,skewX:-0.8,skewY:179.2,x:112.9,y:89},0).wait(2).to({regX:-50.4,regY:14.1,skewX:-1,skewY:179,x:110.6,y:91.8},0).wait(2).to({regX:-48,regY:15.8,skewX:-1.5,skewY:178.5,x:107.5,y:95.1},0).wait(2).to({regX:-50.4,regY:14.1,skewX:-2,skewY:178,x:105.9,y:97.3},0).wait(24).to({regY:11.2,skewX:-1.5,skewY:178.5,x:108.8,y:93},0).wait(2).to({regY:14.1,skewX:-1,skewY:179,x:111.7,y:90.4},0).wait(2).to({regY:14,skewX:-0.5,skewY:179.5,x:114.7,y:86.9},0).wait(2).to({regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(16).to({regX:-50.2,skewX:-0.3,skewY:179.7,x:115.2,y:86.2},0).wait(2).to({regX:-50.3,regY:14.2,skewX:-0.8,skewY:179.2,x:112.9,y:89},0).wait(32).to({regX:-50.4,regY:14.1,skewX:-1,skewY:179,x:111.7,y:90.4},0).wait(2).to({regY:14,skewX:-0.5,skewY:179.5,x:114.7,y:86.9},0).wait(2).to({regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(32).to({_off:true},20).wait(167).to({_off:false},0).wait(5).to({regX:-50.2,skewX:-0.3,skewY:179.7,x:115.2,y:86.2},0).wait(2).to({regX:-50.3,regY:14.2,skewX:-0.8,skewY:179.2,x:112.9,y:89},0).wait(2).to({regX:-50.4,regY:14.1,skewX:-1,skewY:179,x:110.6,y:91.8},0).wait(2).to({regX:-48,regY:15.8,skewX:-1.5,skewY:178.5,x:107.5,y:95.1},0).wait(2).to({regX:-50.4,regY:14.1,skewX:-2,skewY:178,x:105.9,y:97.3},0).wait(24).to({regY:11.2,skewX:-1.5,skewY:178.5,x:108.8,y:93},0).wait(2).to({regY:14.1,skewX:-1,skewY:179,x:111.7,y:90.4},0).wait(2).to({regY:14,skewX:-0.5,skewY:179.5,x:114.7,y:86.9},0).wait(2).to({regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(19));
	this.timeline.addTween(cjs.Tween.get(this.walrus_head_1).wait(176).to({_off:false},0).wait(10).to({regY:14.2,skewX:-0.6,skewY:179.4,x:116.4,y:85.5},0).wait(2).to({regX:-50.3,regY:14.1,skewX:-1.5,skewY:178.5,x:115.3,y:87.4},0).wait(2).to({regX:-50.4,regY:14,skewX:-0.6,skewY:179.4,x:116.5,y:85.4},0).wait(2).to({regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(2).to({regY:14.2,skewX:3.3,skewY:183.3,x:118.8,y:82.1},0).wait(2).to({regX:-50.3,regY:14.3,skewX:6.8,skewY:186.8,x:119.9,y:80.9},0).wait(2).to({regX:-50.4,regY:14.1,skewX:10.3,skewY:190.3,x:121,y:79.5},0).wait(2).to({regX:-50.8,regY:14.2,skewX:14,skewY:194,x:122.2,y:78.3},0).wait(2).to({regY:13.9,scaleX:0.33,scaleY:0.33,skewX:20.3,skewY:200.3,x:126.4,y:76.6},0).wait(2).to({regY:14.3,skewX:26.8,skewY:206.8,x:130.5,y:75},0).wait(2).to({regX:-51.1,regY:14.2,scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:134.7,y:73.4},0).wait(2).to({regX:-51.2,regY:14.1,scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:135.8,y:73.2},0).wait(2).to({regX:-51.1,regY:14.2,scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:137.1,y:73},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:136.3,y:73.2},0).wait(2).to({x:135.5,y:73.3},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:134.7,y:73.4},0).wait(2).to({regX:-51.2,regY:14.1,scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:135.8,y:73.2},0).wait(2).to({regX:-51.1,regY:14.2,scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:137.1,y:73},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:136.3,y:73.2},0).wait(2).to({x:135.5,y:73.3},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:134.7,y:73.4},0).wait(2).to({regX:-51.2,regY:14.1,scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:135.8,y:73.2},0).wait(2).to({regX:-51.1,regY:14.2,scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:137.1,y:73},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.1,skewY:213.1,x:136.3,y:73.2},0).wait(2).to({x:135.5,y:73.3},0).wait(2).to({scaleX:0.33,scaleY:0.33,skewX:33.2,skewY:213.2,x:134.7,y:73.4},0).wait(6).to({regX:-51.2,scaleX:0.33,scaleY:0.33,skewX:24.6,skewY:204.6,x:128.5,y:75.8},0).wait(2).to({regX:-50.8,regY:14.8,scaleX:0.33,scaleY:0.33,skewX:16,skewY:196,x:122.2,y:78},0).wait(2).to({regX:-50.7,skewX:7.8,skewY:187.8,x:119.9,y:80.7},0).wait(2).to({regX:-50.4,regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(2).to({regY:14.2,skewX:-0.6,skewY:179.4,x:117,y:83.9},0).wait(2).to({regY:11.3,skewX:-1.5,skewY:178.5,x:116.4,y:84.2},0).wait(2).to({skewX:-0.8,skewY:179.2,x:116.8,y:83.9},0).wait(2).to({regX:-48.6,skewX:-0.3,skewY:179.7,x:116.6,y:83.7},0).wait(2).to({regX:-50.4,regY:14.1,skewX:0,skewY:180,x:117.6,y:83.4},0).wait(4).to({_off:true},81).wait(62));

	// Walrus Neck
	this.instance_7 = new lib.WalrusNeck_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(108.8,85.1,0.29,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(32).to({skewX:-11.5,skewY:168.5,x:106.9,y:87.3},0).wait(2).to({skewX:-23,skewY:157,x:104.9,y:89.4},0).wait(2).to({skewX:-34.6,skewY:145.4,x:103,y:91.6},0).wait(2).to({skewX:-46.1,skewY:133.9,x:101,y:93.8},0).wait(2).to({skewX:-57.7,skewY:122.3,x:99.1,y:96},0).wait(24).to({skewX:-43.3,skewY:136.7,x:101.5,y:93.3},0).wait(2).to({skewX:-28.8,skewY:151.2,x:103.9,y:90.5},0).wait(2).to({skewX:-14.3,skewY:165.7,x:106.4,y:87.8},0).wait(2).to({skewX:0,skewY:180,x:108.8,y:85.1},0).wait(16).to({skewX:-11.5,skewY:168.5,x:106.9,y:87.3},0).wait(2).to({skewX:-23,skewY:157,x:104.9,y:89.4},0).wait(32).to({skewX:-28.8,skewY:151.2,x:103.9,y:90.5},0).wait(2).to({skewX:-14.3,skewY:165.7,x:106.4,y:87.8},0).wait(2).to({skewX:0,skewY:180,x:108.8,y:85.1},0).wait(62).to({skewX:-4,skewY:176,x:107.7,y:87.4},0).wait(2).to({skewX:-8.2,skewY:171.8,x:106.7,y:89.8},0).wait(2).to({skewX:-4,skewY:176,x:107.8,y:87.4},0).wait(2).to({skewX:0,skewY:180,x:108.8,y:85.1},0).wait(2).to({skewX:-5,skewY:175,x:110.6,y:83},0).wait(2).to({skewX:-10.3,skewY:169.7,x:112.4,y:81},0).wait(2).to({skewX:-15.5,skewY:164.5,x:114.1,y:78.9},0).wait(2).to({skewX:-20.7,skewY:159.3,x:115.9,y:76.9},0).wait(2).to({skewX:-14.3,skewY:165.7,x:120.3,y:74.6},0).wait(2).to({skewX:-7.8,skewY:172.2,x:124.7,y:72.3},0).wait(2).to({skewX:-1.5,skewY:178.5,x:129.1,y:70.1},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.2,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:131.3,y:69.7},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.6,y:69.8},0).wait(2).to({x:129.9,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:129.1,y:70.1},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.2,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:131.3,y:69.7},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.6,y:69.8},0).wait(2).to({x:129.9,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:129.1,y:70.1},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.2,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:131.3,y:69.7},0).wait(2).to({skewX:-1.3,skewY:178.7,x:130.6,y:69.8},0).wait(2).to({x:129.9,y:69.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:129.1,y:70.1},0).wait(6).to({skewX:-0.6,skewY:179.4,x:122.2,y:73.6},0).wait(2).to({skewX:0,skewY:180,x:115.3,y:77},0).wait(2).to({x:112,y:81.1},0).wait(2).to({x:108.8,y:85.1},0).wait(2).to({skewX:-2,skewY:178,x:108.3,y:86.2},0).wait(2).to({skewX:-4.2,skewY:175.8,x:107.8,y:87.3},0).wait(2).to({skewX:-2.8,skewY:177.2,x:108.2,y:86.6},0).wait(2).to({skewX:-1.3,skewY:178.7,x:108.5,y:85.9},0).wait(2).to({skewX:0,skewY:180,x:108.8,y:85.1},0).wait(90).to({skewX:-11.5,skewY:168.5,x:106.9,y:87.3},0).wait(2).to({skewX:-23,skewY:157,x:104.9,y:89.4},0).wait(2).to({skewX:-34.6,skewY:145.4,x:103,y:91.6},0).wait(2).to({skewX:-46.1,skewY:133.9,x:101,y:93.8},0).wait(2).to({skewX:-57.7,skewY:122.3,x:99.1,y:96},0).wait(24).to({skewX:-43.3,skewY:136.7,x:101.5,y:93.3},0).wait(2).to({skewX:-28.8,skewY:151.2,x:103.9,y:90.5},0).wait(2).to({skewX:-14.3,skewY:165.7,x:106.4,y:87.8},0).wait(2).to({skewX:0,skewY:180,x:108.8,y:85.1},0).wait(19));

	// Walrus Shoulder
	this.instance_8 = new lib.WalrusShoulder_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(112.9,113.2,0.328,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(32).to({skewX:-0.3,skewY:179.7,x:113.2,y:114.5},0).wait(2).to({skewX:-0.8,skewY:179.2,x:113.4,y:115.8},0).wait(2).to({skewX:-1,skewY:178.9,x:113.7,y:117.1},0).wait(2).to({skewX:-1.5,skewY:178.5,x:114,y:118.4},0).wait(2).to({skewX:-2,skewY:178,x:114.3,y:119.7},0).wait(24).to({skewX:-1.5,skewY:178.5,x:113.9,y:118.1},0).wait(2).to({skewX:-1,skewY:179,x:113.6,y:116.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:113.2,y:114.8},0).wait(2).to({skewX:0,skewY:180,x:112.9,y:113.2},0).wait(16).to({skewX:-0.3,skewY:179.7,x:113.2,y:114.5},0).wait(2).to({skewX:-0.8,skewY:179.2,x:113.4,y:115.8},0).wait(32).to({skewX:-1,skewY:179,x:113.6,y:116.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:113.2,y:114.8},0).wait(2).to({skewX:0,skewY:180,x:112.9,y:113.2},0).wait(58).to({scaleX:0.33,skewX:11.3,skewY:191.3},0).wait(2).to({scaleX:0.33,skewX:23,skewY:203},0).wait(2).to({scaleX:0.33,scaleY:0.28,skewX:24.1,skewY:201.8,y:115.1},0).wait(2).to({scaleX:0.32,scaleY:0.26,skewX:25.4,skewY:200.8,y:116.9},0).wait(2).to({scaleX:0.33,scaleY:0.28,skewX:24.1,skewY:201.8,y:115.1},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:23,skewY:203,y:113.2},0).wait(2).to({scaleX:0.33,skewX:20.6,skewY:200.6,x:113.2,y:112.7},0).wait(2).to({skewX:18.3,skewY:198.3,x:113.5,y:112.2},0).wait(2).to({skewX:16.1,skewY:196.1,x:113.8,y:111.8},0).to({_off:true},2).wait(48).to({_off:false,scaleX:0.33,skewX:23,skewY:203,x:112.9,y:113.2},0).wait(2).to({scaleX:0.33,scaleY:0.28,skewX:23.5,skewY:202.3,y:114.1},0).wait(2).to({scaleX:0.33,scaleY:0.28,skewX:24.1,skewY:201.9,y:115},0).wait(2).to({scaleX:0.33,scaleY:0.28,skewX:23.6,skewY:202.3,y:114.4},0).wait(2).to({scaleY:0.28,skewX:23.3,skewY:202.6,y:113.8},0).wait(2).to({scaleX:0.33,scaleY:0.29,skewX:23,skewY:203,y:113.2},0).wait(2).to({scaleX:0.33,skewX:11.3,skewY:191.3},0).wait(2).to({scaleX:0.33,skewX:0,skewY:180},0).wait(86).to({skewX:-0.3,skewY:179.7,x:113.2,y:114.5},0).wait(2).to({skewX:-0.8,skewY:179.2,x:113.4,y:115.8},0).wait(2).to({skewX:-1,skewY:178.9,x:113.7,y:117.1},0).wait(2).to({skewX:-1.5,skewY:178.5,x:114,y:118.4},0).wait(2).to({skewX:-2,skewY:178,x:114.3,y:119.7},0).wait(24).to({skewX:-1.5,skewY:178.5,x:113.9,y:118.1},0).wait(2).to({skewX:-1,skewY:179,x:113.6,y:116.5},0).wait(2).to({skewX:-0.5,skewY:179.5,x:113.2,y:114.8},0).wait(2).to({skewX:0,skewY:180,x:112.9,y:113.2},0).wait(19));

	// Walrus Fin
	this.instance_9 = new lib.WalrusFin_excited_002_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(113.2,118.2,0.348,0.348,0,57.9,-122.1,16.3,-27.4);
	this.instance_9._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(192).to({_off:false},0).wait(2).to({regX:16.2,regY:-27.2,scaleX:0.35,scaleY:0.35,skewX:53.4,skewY:-126.6,x:113.3,y:118.1},0).wait(2).to({regX:16.4,skewX:48.7,skewY:-131.3,y:117.9},0).wait(2).to({regX:16.3,regY:-27.4,skewX:44.1,skewY:-135.9,x:113.4,y:117.6},0).to({_off:true},2).wait(205));

	// Walrus Fin
	this.walrus_foot = new lib.WalrusFin();
	this.walrus_foot.parent = this;
	this.walrus_foot.setTransform(113.2,118.2,0.348,0.348,0,0,180,16.2,-27.3);

	this.walrus_foot_1 = new lib.WalrusFin_excited_1();
	this.walrus_foot_1.parent = this;
	this.walrus_foot_1.setTransform(113.2,118.2,0.348,0.348,0,0,180,16.2,-27.3);
	this.walrus_foot_1._off = true;

	this.walrus_foot_2 = new lib.WalrusFin_excited_002_1();
	this.walrus_foot_2.parent = this;
	this.walrus_foot_2.setTransform(113.2,121.4,0.322,0.338,0,60.7,-125,16.2,-27.4);
	this.walrus_foot_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.walrus_foot).wait(32).to({regY:-27.4,skewX:-3.5,skewY:176.5,x:113.3,y:119.7},0).wait(2).to({skewX:-7,skewY:173,x:113.4,y:121.3},0).wait(2).to({regX:16.3,regY:-27.2,skewX:-10.5,skewY:169.5,y:122.8},0).wait(2).to({regX:16.5,regY:-27.7,scaleX:0.35,scaleY:0.35,skewX:-14,skewY:166,y:124.3},0).wait(2).to({regX:16.1,regY:-27.6,scaleX:0.35,scaleY:0.35,skewX:-17.7,skewY:162.3,x:113.6,y:125.8},0).wait(24).to({regX:15.8,regY:-28.2,scaleX:0.35,scaleY:0.35,skewX:-13.3,skewY:166.7,y:123.6},0).wait(2).to({regX:16.5,regY:-28,scaleX:0.35,scaleY:0.35,skewX:-8.8,skewY:171.2,x:113.3,y:121.9},0).wait(2).to({regX:15.7,regY:-27.6,skewX:-4.3,skewY:175.7,x:113.5,y:120.1},0).wait(2).to({regX:16.2,regY:-27.3,skewX:0,skewY:180,x:113.2,y:118.2},0).wait(16).to({regY:-27.4,skewX:-3.5,skewY:176.5,x:113.3,y:119.7},0).wait(2).to({skewX:-7,skewY:173,x:113.4,y:121.3},0).wait(32).to({regX:16.5,regY:-28,skewX:-8.8,skewY:171.2,x:113.3,y:121.9},0).wait(2).to({regX:15.7,regY:-27.6,skewX:-4.3,skewY:175.7,x:113.5,y:120.1},0).wait(2).to({regX:16.2,regY:-27.3,skewX:0,skewY:180,x:113.2,y:118.2},0).wait(32).to({_off:true},20).wait(167).to({_off:false},0).wait(5).to({regY:-27.4,skewX:-3.5,skewY:176.5,x:113.3,y:119.7},0).wait(2).to({skewX:-7,skewY:173,x:113.4,y:121.3},0).wait(2).to({regX:16.3,regY:-27.2,skewX:-10.5,skewY:169.5,y:122.8},0).wait(2).to({regX:16.5,regY:-27.7,scaleX:0.35,scaleY:0.35,skewX:-14,skewY:166,y:124.3},0).wait(2).to({regX:16.1,regY:-27.6,scaleX:0.35,scaleY:0.35,skewX:-17.7,skewY:162.3,x:113.6,y:125.8},0).wait(24).to({regX:15.8,regY:-28.2,scaleX:0.35,scaleY:0.35,skewX:-13.3,skewY:166.7,y:123.6},0).wait(2).to({regX:16.5,regY:-28,scaleX:0.35,scaleY:0.35,skewX:-8.8,skewY:171.2,x:113.3,y:121.9},0).wait(2).to({regX:15.7,regY:-27.6,skewX:-4.3,skewY:175.7,x:113.5,y:120.1},0).wait(2).to({regX:16.2,regY:-27.3,skewX:0,skewY:180,x:113.2,y:118.2},0).wait(19));
	this.timeline.addTween(cjs.Tween.get(this.walrus_foot_1).wait(176).to({_off:false},0).wait(6).to({regX:16.1,regY:-27.2,scaleX:0.35,scaleY:0.35,skewX:28.8,skewY:208.8,x:113.1,y:118.3},0).wait(2).to({regX:16.3,regY:-27.4,scaleX:0.35,scaleY:0.35,skewX:57.9,skewY:237.9,x:113.2,y:118.2},0).wait(2).to({regX:16.4,regY:-27.2,scaleX:0.33,scaleY:0.34,skewX:59.4,skewY:236.4,x:113.1,y:119.8},0).to({_off:true},2).wait(70).to({_off:false,regX:16.3,regY:-27.4,scaleX:0.35,scaleY:0.35,skewX:57.9,skewY:237.9,x:113.2,y:118.2},0).wait(2).to({regX:16.1,scaleX:0.35,scaleY:0.35,skewX:28.8,skewY:208.8},0).wait(2).to({regX:16.2,regY:-27.3,scaleX:0.35,scaleY:0.35,skewX:0,skewY:180},0).to({_off:true},81).wait(62));
	this.timeline.addTween(cjs.Tween.get(this.walrus_foot_2).wait(188).to({_off:false},0).wait(2).to({regX:16.3,scaleX:0.35,scaleY:0.35,skewX:57.9,skewY:-122.1,y:118.2},0).to({_off:true},2).wait(56).to({_off:false},0).wait(4).to({regX:16.2,regY:-27.5,scaleX:0.34,scaleY:0.34,skewX:59.3,skewY:-123.4,y:119.8},0).wait(2).to({regX:16.1,regY:-27.7,scaleX:0.34,scaleY:0.34,skewX:58.9,skewY:-122.9,x:113.3,y:119.3},0).wait(2).to({regY:-27.4,scaleX:0.34,scaleY:0.35,skewX:58.4,skewY:-122.6,x:113.1,y:118.7},0).to({_off:true},2).wait(147));

	// Walrus Tail
	this.instance_10 = new lib.WalrusTail_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(171.7,113.1,0.29,0.29,0,0,180,13.6,-38.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(176).to({y:113.3},0).wait(10).to({skewX:4.1,skewY:184.1},0).wait(2).to({regX:13.4,regY:-38.2,skewX:8.5,skewY:188.5},0).wait(2).to({regY:-38.3,skewX:7,skewY:187},0).wait(2).to({regX:13.2,regY:-38.6,skewX:5.5,skewY:185.5,x:171.8,y:113.1},0).wait(2).to({regY:-38.3,skewX:4.1,skewY:184.1,x:171.7,y:113.3},0).wait(2).to({regX:13.4,regY:-38.4,skewX:2.8,skewY:182.8,y:113.2},0).wait(2).to({regX:13.5,regY:-38.1,skewX:1.3,skewY:181.3,y:113.3},0).wait(2).to({regX:13.6,skewX:0,skewY:180},0).wait(6).to({y:112.3},0).wait(2).to({regY:-38.5,skewX:4.1,skewY:184.1,x:172.2,y:112.1},0).wait(2).to({regX:13.8,regY:-38.2,skewX:8.5,skewY:188.5,x:172.7,y:112.2},0).wait(2).to({regX:13.6,skewX:5.5,skewY:185.5,x:172.4},0).wait(2).to({regX:13.8,regY:-38,skewX:2.8,skewY:182.8,x:172.1,y:112.3},0).wait(2).to({regX:13.6,regY:-38.1,skewX:0,skewY:180,x:171.7},0).wait(2).to({regY:-38.5,skewX:4.1,skewY:184.1,x:172.2,y:112.1},0).wait(2).to({regX:13.8,regY:-38.2,skewX:8.5,skewY:188.5,x:172.7,y:112.2},0).wait(2).to({regX:13.6,skewX:5.5,skewY:185.5,x:172.4},0).wait(2).to({regX:13.8,regY:-38,skewX:2.8,skewY:182.8,x:172.1,y:112.3},0).wait(2).to({regX:13.6,regY:-38.1,skewX:0,skewY:180,x:171.7},0).wait(2).to({regY:-38.5,skewX:4.1,skewY:184.1,x:172.2,y:112.1},0).wait(2).to({regX:13.8,regY:-38.2,skewX:8.5,skewY:188.5,x:172.7,y:112.2},0).wait(2).to({regX:13.6,skewX:5.5,skewY:185.5,x:172.4},0).wait(2).to({regX:13.8,regY:-38,skewX:2.8,skewY:182.8,x:172.1,y:112.3},0).wait(2).to({regX:13.6,regY:-38.1,skewX:0,skewY:180,x:171.7},0).wait(6).to({y:112.5},0).wait(2).to({y:112.8},0).wait(2).to({y:112.9},0).wait(2).to({y:113.1},0).wait(157));

	// Walrus Roll 3
	this.instance_11 = new lib.WalrusRoll3_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(108.4,95.8,0.29,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(32).to({skewX:-0.3,skewY:179.7,x:107.4,y:96.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:106.5,y:97},0).wait(2).to({skewX:-1,skewY:179,x:105.6,y:97.6},0).wait(2).to({skewX:-1.5,skewY:178.5,x:104.6,y:98.3},0).wait(2).to({skewX:-2,skewY:178,x:103.7,y:98.9},0).wait(24).to({skewX:-1.5,skewY:178.5,x:104.8,y:98.1},0).wait(2).to({skewX:-1,skewY:179,x:106,y:97.3},0).wait(2).to({skewX:-0.5,skewY:179.5,x:107.2,y:96.5},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(16).to({skewX:-0.3,skewY:179.7,x:107.4,y:96.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:106.5,y:97},0).wait(32).to({skewX:-1,skewY:179,x:106,y:97.3},0).wait(2).to({skewX:-0.5,skewY:179.5,x:107.2,y:96.5},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(62).to({skewX:-4,skewY:176,x:108,y:98.1},0).wait(2).to({skewX:-8.2,skewY:171.8,x:107.7,y:100.4},0).wait(2).to({skewX:-4,skewY:176,x:108,y:98.1},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(2).to({skewX:3.3,skewY:183.3,x:110.5,y:92.8},0).wait(2).to({skewX:6.8,skewY:186.8,x:112.6,y:89.8},0).wait(2).to({skewX:10.3,skewY:190.3,x:114.8,y:86.9},0).wait(2).to({skewX:14,skewY:194,x:116.9,y:83.9},0).wait(2).to({skewX:20.3,skewY:200.3,x:120.5,y:81.6},0).wait(2).to({skewX:26.8,skewY:206.8,x:124.2,y:79.2},0).wait(2).to({skewX:33.2,skewY:213.2,x:127.8,y:76.9},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.6},0).wait(2).to({skewX:33.2,skewY:213.2,x:129.4},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.9,y:77},0).wait(2).to({x:128.4},0).wait(2).to({skewX:33.2,skewY:213.2,x:127.8,y:76.9},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.6},0).wait(2).to({skewX:33.2,skewY:213.2,x:129.4},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.9,y:77},0).wait(2).to({x:128.4},0).wait(2).to({skewX:33.2,skewY:213.2,x:127.8,y:76.9},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.6},0).wait(2).to({skewX:33.2,skewY:213.2,x:129.4},0).wait(2).to({skewX:33.1,skewY:213.1,x:128.9,y:77},0).wait(2).to({x:128.4},0).wait(2).to({skewX:33.2,skewY:213.2,x:127.8,y:76.9},0).wait(6).to({skewX:23.1,skewY:203.1,x:122,y:82.6},0).wait(2).to({skewX:13.3,skewY:193.3,x:116.2,y:88.2},0).wait(2).to({skewX:6.5,skewY:186.5,x:112.3,y:92},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(2).to({skewX:-2,skewY:178,x:108.2,y:96.9},0).wait(2).to({skewX:-4.2,skewY:175.8,x:108.1,y:98.1},0).wait(2).to({skewX:-2.8,skewY:177.2,x:108.2,y:97.3},0).wait(2).to({skewX:-1.3,skewY:178.7,x:108.3,y:96.5},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(90).to({skewX:-0.3,skewY:179.7,x:107.4,y:96.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:106.5,y:97},0).wait(2).to({skewX:-1,skewY:179,x:105.6,y:97.6},0).wait(2).to({skewX:-1.5,skewY:178.5,x:104.6,y:98.3},0).wait(2).to({skewX:-2,skewY:178,x:103.7,y:98.9},0).wait(24).to({skewX:-1.5,skewY:178.5,x:104.8,y:98.1},0).wait(2).to({skewX:-1,skewY:179,x:106,y:97.3},0).wait(2).to({skewX:-0.5,skewY:179.5,x:107.2,y:96.5},0).wait(2).to({skewX:0,skewY:180,x:108.4,y:95.8},0).wait(19));

	// Walrus Roll 4
	this.instance_12 = new lib.WalrusRoll4_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(112,101.1,0.365,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(32).to({skewX:-0.3,skewY:179.7,x:111.4,y:101.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:110.8,y:101.7},0).wait(2).to({skewX:-1,skewY:179,x:110.2,y:101.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:109.6,y:102.2},0).wait(2).to({skewX:-2,skewY:178,x:109,y:102.5},0).wait(24).to({skewX:-1.5,skewY:178.5,x:109.7,y:102.2},0).wait(2).to({skewX:-1,skewY:179,x:110.4,y:101.8},0).wait(2).to({skewX:-0.5,skewY:179.5,x:111.3,y:101.5},0).wait(2).to({skewX:0,skewY:180,x:112,y:101.1},0).wait(16).to({skewX:-0.3,skewY:179.7,x:111.4,y:101.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:110.8,y:101.7},0).wait(32).to({skewX:-1,skewY:179,x:110.4,y:101.8},0).wait(2).to({skewX:-0.5,skewY:179.5,x:111.3,y:101.5},0).wait(2).to({skewX:0,skewY:180,x:112,y:101.1},0).wait(62).to({skewX:-4,skewY:176,x:112.1,y:103.2},0).wait(2).to({skewX:-8.2,skewY:171.8,y:105.2},0).wait(2).to({skewX:-4,skewY:176,x:112,y:103.1},0).wait(2).to({skewX:0,skewY:180,y:101.1},0).wait(2).to({skewX:3.3,skewY:183.3,x:113.7,y:98.4},0).wait(2).to({skewX:6.8,skewY:186.8,x:115.3,y:95.8},0).wait(2).to({skewX:10.3,skewY:190.3,x:116.9,y:93.1},0).wait(2).to({skewX:14,skewY:194,x:118.6,y:90.4},0).wait(2).to({skewX:20.3,skewY:200.3,x:121.5,y:88.2},0).wait(2).to({scaleX:0.36,skewX:26.8,skewY:206.8,x:124.3,y:85.9},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:127.2,y:83.6},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128,y:83.7},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:128.8,y:83.6},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128.3},0).wait(2).to({x:127.8},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:127.2},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128,y:83.7},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:128.8,y:83.6},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128.3},0).wait(2).to({x:127.8},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:127.2},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128,y:83.7},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:128.8,y:83.6},0).wait(2).to({scaleX:0.36,skewX:33.1,skewY:213.1,x:128.3},0).wait(2).to({x:127.8},0).wait(2).to({scaleX:0.37,skewX:33.2,skewY:213.2,x:127.2},0).wait(6).to({scaleX:0.36,skewX:23.1,skewY:203.1,x:122.6,y:88.9},0).wait(2).to({scaleX:0.37,skewX:13.3,skewY:193.3,x:118.1,y:94.1},0).wait(2).to({skewX:6.5,skewY:186.5,x:115.1,y:97.6},0).wait(2).to({skewX:0,skewY:180,x:112,y:101.1},0).wait(2).to({skewX:-2,skewY:178,x:112.1,y:102.1},0).wait(2).to({skewX:-4.2,skewY:175.8,x:112.2,y:103.1},0).wait(2).to({skewX:-2.8,skewY:177.2,x:112.1,y:102.5},0).wait(2).to({skewX:-1.3,skewY:178.7,y:101.8},0).wait(2).to({skewX:0,skewY:180,x:112,y:101.1},0).wait(90).to({skewX:-0.3,skewY:179.7,x:111.4,y:101.4},0).wait(2).to({skewX:-0.8,skewY:179.2,x:110.8,y:101.7},0).wait(2).to({skewX:-1,skewY:179,x:110.2,y:101.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:109.6,y:102.2},0).wait(2).to({skewX:-2,skewY:178,x:109,y:102.5},0).wait(24).to({skewX:-1.5,skewY:178.5,x:109.7,y:102.2},0).wait(2).to({skewX:-1,skewY:179,x:110.4,y:101.8},0).wait(2).to({skewX:-0.5,skewY:179.5,x:111.3,y:101.5},0).wait(2).to({skewX:0,skewY:180,x:112,y:101.1},0).wait(19));

	// Walrus Roll 2
	this.walrus_roll1 = new lib.WalrusRoll2();
	this.walrus_roll1.parent = this;
	this.walrus_roll1.setTransform(116.3,106,0.29,0.29,0,0,180,0,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.walrus_roll1).wait(32).to({skewX:-1.3,skewY:178.7,x:116.2,y:106.2},0).wait(2).to({skewX:-2.8,skewY:177.2,x:116.1,y:106.4},0).wait(2).to({skewX:-4,skewY:176,x:116,y:106.7},0).wait(2).to({skewX:-5.5,skewY:174.5,x:115.9,y:106.9},0).wait(2).to({skewX:-7,skewY:173,x:115.8,y:107.1},0).wait(24).to({skewX:-5.1,skewY:174.9,x:115.9,y:106.8},0).wait(2).to({skewX:-3.3,skewY:176.7,x:116,y:106.6},0).wait(2).to({regX:-0.2,skewX:-1.6,skewY:178.4,x:116.2,y:106.3},0).wait(2).to({regX:0,skewX:0,skewY:180,x:116.3,y:106},0).wait(16).to({skewX:-1.3,skewY:178.7,x:116.2,y:106.2},0).wait(2).to({skewX:-2.8,skewY:177.2,x:116.1,y:106.4},0).wait(32).to({skewX:-3.3,skewY:176.7,x:116,y:106.6},0).wait(2).to({regX:-0.2,skewX:-1.6,skewY:178.4,x:116.2,y:106.3},0).wait(2).to({regX:0,skewX:0,skewY:180,x:116.3,y:106},0).wait(62).to({skewX:-4,skewY:176,x:116.7,y:107.7},0).wait(2).to({skewX:-8.2,skewY:171.8,x:117.1,y:109.4},0).wait(2).to({skewX:-4,skewY:176,x:116.7,y:107.7},0).wait(2).to({skewX:0,skewY:180,x:116.3,y:106},0).wait(2).to({regX:-0.1,regY:-0.2,skewX:3.3,skewY:183.3,x:117.3,y:103.7},0).wait(2).to({regX:0,regY:-0.1,skewX:6.8,skewY:186.8,x:118.3,y:101.4},0).wait(2).to({regX:0.1,skewX:10.3,skewY:190.3,x:119.2,y:99},0).wait(2).to({regX:-0.1,regY:-0.2,skewX:14,skewY:194,x:120.3,y:96.7},0).wait(2).to({regX:-0.2,regY:-0.3,scaleY:0.3,skewX:21.5,skewY:201.5,x:122.3,y:94.4},0).wait(2).to({regX:-0.5,regY:-0.2,scaleY:0.3,skewX:29.1,skewY:209.1,x:124.2,y:92.1},0).wait(2).to({regX:-0.2,regY:0.1,scaleY:0.31,skewX:36.7,skewY:216.7,x:126.1,y:89.8},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:126.7},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:127.5},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:127},0).wait(2).to({x:126.5},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:126.1},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:126.7},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:127.5},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:127},0).wait(2).to({x:126.5},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:126.1},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:126.7},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:127.5},0).wait(2).to({scaleY:0.31,skewX:36.6,skewY:216.6,x:127},0).wait(2).to({x:126.5},0).wait(2).to({scaleY:0.31,skewX:36.7,skewY:216.7,x:126.1},0).wait(6).to({scaleY:0.3,skewX:25.6,skewY:205.6,x:123.2,y:94.8},0).wait(2).to({regX:-0.6,regY:0.2,scaleY:0.3,skewX:14.6,skewY:194.6,x:120.3,y:99.6},0).wait(2).to({regY:0.1,scaleY:0.29,skewX:7.3,skewY:187.3,x:118.3,y:102.8},0).wait(2).to({regX:0,regY:-0.1,scaleY:0.29,skewX:0,skewY:180,x:116.3,y:106},0).wait(2).to({skewX:-2,skewY:178,x:116.6,y:106.8},0).wait(2).to({skewX:-4.2,skewY:175.8,x:116.8,y:107.6},0).wait(2).to({skewX:-2.8,skewY:177.2,x:116.7,y:107.1},0).wait(2).to({skewX:-1.3,skewY:178.7,x:116.5,y:106.5},0).wait(2).to({skewX:0,skewY:180,x:116.3,y:106},0).wait(90).to({skewX:-1.3,skewY:178.7,x:116.2,y:106.2},0).wait(2).to({skewX:-2.8,skewY:177.2,x:116.1,y:106.4},0).wait(2).to({skewX:-4,skewY:176,x:116,y:106.7},0).wait(2).to({skewX:-5.5,skewY:174.5,x:115.9,y:106.9},0).wait(2).to({skewX:-7,skewY:173,x:115.8,y:107.1},0).wait(24).to({skewX:-5.1,skewY:174.9,x:115.9,y:106.8},0).wait(2).to({skewX:-3.3,skewY:176.7,x:116,y:106.6},0).wait(2).to({regX:-0.2,skewX:-1.6,skewY:178.4,x:116.2,y:106.3},0).wait(2).to({regX:0,skewX:0,skewY:180,x:116.3,y:106},0).wait(19));

	// Walrus Roll 7
	this.walrus_roll2 = new lib.WalrusRoll7();
	this.walrus_roll2.parent = this;
	this.walrus_roll2.setTransform(126.5,110.8,0.29,0.29,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.walrus_roll2).wait(32).to({x:126.6},0).wait(2).to({skewX:-0.1,skewY:179.9,y:110.9},0).wait(2).to({skewX:-0.3,skewY:179.7,x:126.7},0).wait(2).to({x:126.8},0).wait(2).to({skewX:-0.6,skewY:179.4,x:126.9,y:111},0).wait(24).to({skewX:-0.3,skewY:179.7,x:126.8,y:110.9},0).wait(2).to({x:126.7,y:110.8},0).wait(2).to({skewX:0,skewY:180,x:126.6},0).wait(2).to({x:126.5},0).wait(16).to({x:126.6},0).wait(2).to({skewX:-0.1,skewY:179.9,y:110.9},0).wait(32).to({skewX:-0.3,skewY:179.7,x:126.7,y:110.8},0).wait(2).to({skewX:0,skewY:180,x:126.6},0).wait(2).to({x:126.5},0).wait(62).to({skewX:-4,skewY:176,x:127.1,y:111.8},0).wait(2).to({skewX:-8.2,skewY:171.8,x:127.7,y:112.7},0).wait(2).to({skewX:-4,skewY:176,x:127.1,y:111.8},0).wait(2).to({skewX:0,skewY:180,x:126.5,y:110.8},0).wait(2).to({skewX:3.3,skewY:183.3,x:127.2,y:109.2},0).wait(2).to({skewX:6.8,skewY:186.8,x:127.9,y:107.6},0).wait(2).to({skewX:10.3,skewY:190.3,x:128.7,y:106},0).wait(2).to({skewX:14,skewY:194,x:129.4,y:104.4},0).wait(2).to({scaleY:0.31,skewX:28.8,skewY:208.8,x:128.7,y:103.4},0).wait(2).to({scaleX:0.29,scaleY:0.32,skewX:43.6,skewY:223.6,x:127.9,y:102.4},0).wait(2).to({scaleX:0.29,scaleY:0.34,skewX:58.4,skewY:238.4,x:127.1,y:101.4},0).wait(2).to({scaleY:0.34,x:127.7},0).wait(2).to({scaleY:0.34,x:128.3},0).wait(2).to({scaleY:0.34,x:127.9},0).wait(2).to({x:127.5},0).wait(2).to({scaleY:0.34,x:127.1},0).wait(2).to({scaleY:0.34,x:127.7},0).wait(2).to({scaleY:0.34,x:128.3},0).wait(2).to({scaleY:0.34,x:127.9},0).wait(2).to({x:127.5},0).wait(2).to({scaleY:0.34,x:127.1},0).wait(2).to({scaleY:0.34,x:127.7},0).wait(2).to({scaleY:0.34,x:128.3},0).wait(2).to({scaleY:0.34,x:127.9},0).wait(2).to({x:127.5},0).wait(2).to({scaleY:0.34,x:127.1},0).wait(6).to({scaleX:0.29,scaleY:0.33,skewX:40.9,skewY:220.9,x:126.9,y:104.2},0).wait(2).to({scaleX:0.29,scaleY:0.31,skewX:23.3,skewY:203.3,x:126.8,y:107},0).wait(2).to({scaleY:0.3,skewX:11.5,skewY:191.5,x:126.6,y:108.9},0).wait(2).to({scaleY:0.29,skewX:0,skewY:180,x:126.5,y:110.8},0).wait(2).to({skewX:-2,skewY:178,x:126.9,y:111.2},0).wait(2).to({skewX:-4.2,skewY:175.8,x:127.3,y:111.7},0).wait(2).to({skewX:-2.8,skewY:177.2,x:127,y:111.4},0).wait(2).to({skewX:-1.3,skewY:178.7,x:126.8,y:111.1},0).wait(2).to({skewX:0,skewY:180,x:126.5,y:110.8},0).wait(90).to({x:126.6},0).wait(2).to({skewX:-0.1,skewY:179.9,y:110.9},0).wait(2).to({skewX:-0.3,skewY:179.7,x:126.7},0).wait(2).to({x:126.8},0).wait(2).to({skewX:-0.6,skewY:179.4,x:126.9,y:111},0).wait(24).to({skewX:-0.3,skewY:179.7,x:126.8,y:110.9},0).wait(2).to({x:126.7,y:110.8},0).wait(2).to({skewX:0,skewY:180,x:126.6},0).wait(2).to({x:126.5},0).wait(19));

	// Walrus Roll 1
	this.walrus_torso = new lib.WalrusRoll1();
	this.walrus_torso.parent = this;
	this.walrus_torso.setTransform(124.3,106.9,0.29,0.29,0,0,180);

	this.walrus_torso_1 = new lib.WalrusRoll_excited_001();
	this.walrus_torso_1.parent = this;
	this.walrus_torso_1.setTransform(124.3,106.9,0.29,0.29,0,0,180);
	this.walrus_torso_1._off = true;

	this.walrus_torso_2 = new lib.WalrusRoll1_excited_001();
	this.walrus_torso_2.parent = this;
	this.walrus_torso_2.setTransform(126,103.8,0.29,0.29,0,7.8,-172.2);

	this.walrus_torso_3 = new lib.WalrusRoll1_excited_003();
	this.walrus_torso_3.parent = this;
	this.walrus_torso_3.setTransform(127.6,100.6,0.29,0.29,0,15.9,-164.1);

	this.walrus_torso_4 = new lib.WalrusRoll1_excited_003b();
	this.walrus_torso_4.parent = this;
	this.walrus_torso_4.setTransform(128.1,102,0.29,0.312,0,22.1,-168);

	this.walrus_torso_5 = new lib.WalrusRoll1_excited_005();
	this.walrus_torso_5.parent = this;
	this.walrus_torso_5.setTransform(128.4,102.7,0.29,0.324,0,25.2,-169.8);
	this.walrus_torso_5._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.walrus_torso}]}).to({state:[{t:this.walrus_torso}]},16).to({state:[{t:this.walrus_torso}]},14).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},22).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},14).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},32).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},12).to({state:[{t:this.walrus_torso}]},20).to({state:[{t:this.walrus_torso_1}]},20).to({state:[{t:this.walrus_torso_1}]},4).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_2,p:{skewX:7.8,skewY:-172.2,x:126,y:103.8}}]},2).to({state:[{t:this.walrus_torso_2,p:{skewX:11.8,skewY:-168.2,x:126.8,y:102.2}}]},2).to({state:[{t:this.walrus_torso_3,p:{scaleY:0.29,skewX:15.9,skewY:-164.1,x:127.6,y:100.6}}]},2).to({state:[{t:this.walrus_torso_3,p:{scaleY:0.301,skewX:19,skewY:-166.2,x:127.9,y:101.4}}]},2).to({state:[{t:this.walrus_torso_4}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_5}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso_1}]},2).to({state:[{t:this.walrus_torso}]},81).to({state:[{t:this.walrus_torso}]},3).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},22).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).to({state:[{t:this.walrus_torso}]},2).wait(19));
	this.timeline.addTween(cjs.Tween.get(this.walrus_torso).wait(156).to({_off:true},20).wait(167).to({_off:false},0).wait(62));
	this.timeline.addTween(cjs.Tween.get(this.walrus_torso_1).wait(176).to({_off:false},0).wait(10).to({y:107.6},0).wait(2).to({y:108.3},0).wait(2).to({y:107.6},0).wait(2).to({y:106.9},0).wait(2).to({skewX:3.8,skewY:183.8,x:125.1,y:105.3},0).to({_off:true},2).wait(52).to({_off:false,skewX:0,skewY:180,x:124.3,y:106.9},0).wait(14).to({_off:true},81).wait(62));
	this.timeline.addTween(cjs.Tween.get(this.walrus_torso_5).wait(206).to({_off:false},0).wait(2).to({skewX:26.8,skewY:-168.2,x:129,y:102.1},0).wait(2).to({skewX:28.4,skewY:-166.6,x:129.7,y:101.5},0).wait(2).to({skewX:27.3,skewY:-167.7,x:129.3,y:101.9},0).wait(2).to({skewX:26.3,skewY:-168.7,x:128.8,y:102.2},0).wait(2).to({skewX:25.2,skewY:-169.8,x:128.4,y:102.7},0).wait(2).to({skewX:26.8,skewY:-168.2,x:129,y:102.1},0).wait(2).to({skewX:28.4,skewY:-166.6,x:129.7,y:101.5},0).wait(2).to({skewX:27.3,skewY:-167.7,x:129.3,y:101.9},0).wait(2).to({skewX:26.3,skewY:-168.7,x:128.8,y:102.2},0).wait(2).to({skewX:25.2,skewY:-169.8,x:128.4,y:102.7},0).wait(2).to({skewX:26.8,skewY:-168.2,x:129,y:102.1},0).wait(2).to({skewX:28.4,skewY:-166.6,x:129.7,y:101.5},0).wait(2).to({skewX:27.3,skewY:-167.7,x:129.3,y:101.9},0).wait(2).to({skewX:26.3,skewY:-168.7,x:128.8,y:102.2},0).wait(2).to({skewX:25.2,skewY:-169.8,x:128.4,y:102.7},0).wait(6).to({scaleY:0.31,skewX:17.5,skewY:-173,x:127.2,y:103.9},0).wait(2).to({scaleY:0.3,skewX:10,skewY:-176,x:126,y:105.2},0).wait(2).to({scaleY:0.3,skewX:5,skewY:-178,x:125.1,y:106},0).to({_off:true},2).wait(157));

	// Walrus Roll 8
	this.walrus_roll3 = new lib.WalrusRoll8();
	this.walrus_roll3.parent = this;
	this.walrus_roll3.setTransform(157.3,114.7,1,1,0,0,180,15.7,15.1);

	this.timeline.addTween(cjs.Tween.get(this.walrus_roll3).wait(186).to({regX:16.2,regY:16,skewX:-2.8,skewY:177.2,x:157.8,y:116.7},0).wait(2).to({regX:13.9,regY:17.2,skewX:-5.9,skewY:174.1,x:159.3,y:116.8},0).wait(2).to({regX:14.3,regY:18.3,skewX:-2.8,skewY:177.2,x:158,y:116.9},0).wait(2).to({regX:15.7,regY:15.1,skewX:0,skewY:180,x:157.3,y:114.7},0).wait(10).to({scaleY:1.03,y:114.4},0).wait(2).to({scaleY:1.05,y:114.1},0).wait(2).to({scaleY:1.08,y:113.9},0).wait(2).to({x:157.8},0).wait(2).to({x:158.3},0).wait(2).to({x:158},0).wait(2).to({x:157.7},0).wait(2).to({x:157.3},0).wait(2).to({x:157.8},0).wait(2).to({x:158.3},0).wait(2).to({x:158},0).wait(2).to({x:157.7},0).wait(2).to({x:157.3},0).wait(2).to({x:157.8},0).wait(2).to({x:158.3},0).wait(2).to({x:158},0).wait(2).to({x:157.7},0).wait(2).to({x:157.3},0).wait(6).to({regY:15.2,scaleY:1.06,y:114.3},0).wait(2).to({scaleY:1.03,y:114.5},0).wait(2).to({scaleY:1.02,y:114.7},0).wait(2).to({regY:15.1,scaleY:1},0).wait(157));

	// Walrus Head
	this.instance_13 = new lib.WalrusFin_excited_002_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(114.3,110.6,0.222,0.222,0,70.7,-109.3,16.4,-27.5);
	this.instance_13._off = true;

	this.instance_14 = new lib.WalrusFin_excited_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(108.5,111.7,0.222,0.222,0,59.7,-120.3,16.6,-28);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(184).to({_off:false},0).wait(2).to({regY:-27.6,scaleX:0.22,scaleY:0.22,y:113.8},0).wait(2).to({regY:-27.5,scaleX:0.22,scaleY:0.22,y:117.2},0).wait(2).to({regY:-27.6,scaleX:0.22,scaleY:0.22,y:113.9},0).wait(2).to({regY:-27.5,scaleX:0.22,scaleY:0.22,y:110.6},0).wait(2).to({regX:16.5,regY:-27.8,scaleX:0.22,scaleY:0.22,skewX:67.2,skewY:-112.8,x:112.4,y:110.9},0).wait(2).to({regX:16.4,regY:-27.4,skewX:63.4,skewY:-116.6,x:110.5,y:111.3},0).wait(2).to({regX:16.6,regY:-28,scaleX:0.22,scaleY:0.22,skewX:59.7,skewY:-120.3,x:108.5,y:111.7},0).to({_off:true},2).wait(48).to({_off:false,regX:16.4,regY:-27.5,skewX:70.7,skewY:-109.3,x:114.3,y:110.6},0).wait(2).to({regY:-27.6,scaleX:0.22,scaleY:0.22,y:112.6},0).wait(2).to({regY:-27.5,scaleX:0.22,scaleY:0.22,y:114.8},0).wait(2).to({regY:-27.6,scaleX:0.22,scaleY:0.22,y:113.4},0).wait(2).to({y:112},0).wait(2).to({regY:-27.5,scaleX:0.22,scaleY:0.22,y:110.6},0).wait(2).to({_off:true},2).wait(143));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(200).to({_off:false},0).wait(2).to({regX:16.4,regY:-28.2,scaleX:0.22,scaleY:0.22,skewX:86.2,skewY:-93.8,x:107.3,y:104.3},0).wait(2).to({regX:16.6,regY:-27.9,skewX:112.3,skewY:-67.7,x:106,y:96.8},0).wait(2).to({regX:16.1,regY:-28.2,skewX:138.9,skewY:-41.1,x:104.8,y:89.2},0).wait(2).to({regX:15.8,regY:-28.1,scaleX:0.2,scaleY:0.21,skewX:151.2,y:89.3},0).wait(2).to({regX:16.1,regY:-28.4,scaleX:0.18,scaleY:0.2,skewX:163.5},0).wait(2).to({scaleX:0.19,scaleY:0.21,skewX:155.4},0).wait(2).to({regX:16,scaleX:0.21,scaleY:0.21,skewX:147.2,y:89.2},0).wait(2).to({regX:16.1,regY:-28.2,scaleX:0.22,scaleY:0.22,skewX:138.9},0).wait(2).to({regX:15.8,regY:-28.1,scaleX:0.2,scaleY:0.21,skewX:151.2,y:89.3},0).wait(2).to({regX:16.1,regY:-28.4,scaleX:0.18,scaleY:0.2,skewX:163.5},0).wait(2).to({scaleX:0.19,scaleY:0.21,skewX:155.4},0).wait(2).to({regX:16,scaleX:0.21,scaleY:0.21,skewX:147.2,y:89.2},0).wait(2).to({regX:16.1,regY:-28.2,scaleX:0.22,scaleY:0.22,skewX:138.9},0).wait(2).to({regX:15.8,regY:-28.1,scaleX:0.2,scaleY:0.21,skewX:151.2,y:89.3},0).wait(2).to({regX:16.1,regY:-28.4,scaleX:0.18,scaleY:0.2,skewX:163.5},0).wait(2).to({scaleX:0.19,scaleY:0.21,skewX:155.4},0).wait(2).to({regX:16,scaleX:0.21,scaleY:0.21,skewX:147.2,y:89.2},0).wait(2).to({regX:16.1,regY:-28.2,scaleX:0.22,scaleY:0.22,skewX:138.9},0).wait(6).to({regX:16,skewX:118.3,skewY:-61.7,x:107.7,y:95.7},0).wait(2).to({regY:-28.4,skewX:97.8,skewY:-82.2,x:110.6,y:102},0).wait(2).to({regX:15.8,skewX:84.2,skewY:-95.8,x:112.5,y:106.3},0).to({_off:true},2).wait(157));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(83.5,69.2,103.7,74.1);


(lib.walrus = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mouthGlow
	this.mouthGlow = new lib.walrus_mouthGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(138.2,112.2,0.954,0.954,0,0,0,24,14.1);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.mouthGlow.cache(-5,-5,58,38);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// footGlow
	this.footGlow = new lib.walrus_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(187.5,220.4,1,1,0,0,0,27.7,30.6);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.footGlow.cache(-5,-5,66,71);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// tummyGlow
	this.tummyGlow = new lib.walrus_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(246.8,201.9,1,1,0,0,0,54,24.2);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.tummyGlow.cache(-3,-2,117,56);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// backGlow
	this.backGlow = new lib.walrus_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(234.4,168.2,1,1,0,0,0,33.1,30.2);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(-17,-27,126,79);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// tummy
	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(253.8,215.1,2.172,0.941,0,-6.6,10);

	this.timeline.addTween(cjs.Tween.get(this.tummy).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(239.9,155.4,3.216,0.865,25.7);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// foot1
	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(174.8,220.3,1.779,1.525,-1.7);

	this.timeline.addTween(cjs.Tween.get(this.foot1).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(323,226.2,0.948,1.186,-95.8);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// mouth
	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(138.8,145.9,1.21,2.177,-4);

	this.timeline.addTween(cjs.Tween.get(this.mouth).wait(1));

	// main
	this.main = new lib.Walrus();
	this.main.parent = this;
	this.main.setTransform(472.8,48.9,2.385,2.385,0,0,180,20.6,55.4);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.walrus, new cjs.Rectangle(75.4,81.8,273.2,179), null);


// stage content:
(lib.MWwalrus = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWwalrus_atlas_.png?1528312690448", id:"MWwalrus_atlas_"}
	],
	preloads: []
};




})(lib_Walrus = lib_Walrus||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Walrus, images, createjs, ss, AdobeAn;